import _toConsumableArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { createTracingClient } from "@azure/core-tracing";
import { SDK_VERSION } from "./constants";
import { accept1 } from "./generated/models/parameters";
import { toTrainingPollOperationState } from "./lro/training";
import { lro } from "./lro/util/poller";
import { Mappers, SERIALIZER, makeServiceClient } from "./util";
/**
 * A client for interacting with the Form Recognizer service's model management features, such as creating, reading,
 * listing, deleting, and copying models.
 *
 * ### Examples:
 *
 * #### Azure Active Directory
 *
 * ```typescript
 * import { DocumentModelAdministrationClient } from "@azure/ai-form-recognizer";
 * import { DefaultAzureCredential } from "@azure/identity";
 *
 * const endpoint = "https://<resource name>.cognitiveservices.azure.com";
 * const credential = new DefaultAzureCredential();
 *
 * const client = new DocumentModelAdministrationClient(endpoint, credential);
 * ```
 *
 * #### API Key (Subscription Key)
 *
 * ```typescript
 * import { DocumentModelAdministrationClient, AzureKeyCredential } from "@azure/ai-form-recognizer";
 *
 * const endpoint = "https://<resource name>.cognitiveservices.azure.com";
 * const credential = new AzureKeyCredential("<api key>");
 *
 * const client = new DocumentModelAdministrationClient(endpoint, credential);
 * ```
 */

export var DocumentModelAdministrationClient = /*#__PURE__*/function () {
  function DocumentModelAdministrationClient(endpoint, credential) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, DocumentModelAdministrationClient);

    this._restClient = makeServiceClient(endpoint, credential, options);
    this._tracing = createTracingClient({
      packageName: "@azure/ai-form-recognizer",
      packageVersion: SDK_VERSION,
      namespace: "Microsoft.CognitiveServices"
    });
  } // #region Model Creation

  /**
   * Build a new model with a given ID from a set of input documents and labeled fields.
   *
   * The Model ID can consist of any text, so long as it does not begin with "prebuilt-" (as these models refer to
   * prebuilt Form Recognizer models that are common to all resources), and so long as it does not already exist within
   * the resource.
   *
   * The Form Recognizer service reads the training data set from an Azure Storage container, given as a URL to the
   * container with a SAS token that allows the service backend to communicate with the container. At a minimum, the
   * "read" and "list" permissions are required. In addition, the data in the given container must be organized
   * according to a particular convention, which is documented in [the service's documentation for building custom
   * models](https://aka.ms/form-recognizer/custom).
   *
   * ### Example
   *
   * ```javascript
   * const modelId = "aNewModel";
   * const containerUrl = "<training data container SAS URL>";
   *
   * const poller = await client.beginBuildModel(modelId, containerUrl, {
   *   // Optionally, a text description may be attached to the model
   *   description: "This is an example model!"
   * });
   *
   * // Model building, like all other model creation operations, returns a poller that eventually produces a ModelInfo
   * // object
   * const modelInfo = await poller.pollUntilDone();
   *
   * const {
   *   modelId, // identical to the modelId given when creating the model
   *   description, // identical to the description given when creating the model
   *   createdDateTime, // the Date (timestamp) that the model was created
   *   docTypes // information about the document types in the model and their field schemas
   * } = modelInfo;
   * ```
   *
   * @param modelId - the unique ID of the model to create
   * @param containerUrl - SAS-encoded URL to an Azure Storage container holding the training data set
   * @param buildMode - the mode to use when building the model (see `DocumentModelBuildMode`)
   * @param options - optional settings for the model build operation
   * @returns a long-running operation (poller) that will eventually produce the created model information or an error
   */


  _createClass(DocumentModelAdministrationClient, [{
    key: "beginBuildModel",
    value: function () {
      var _beginBuildModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(modelId, containerUrl, buildMode) {
        var _this = this;

        var options,
            _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                return _context.abrupt("return", this._tracing.withSpan("DocumentModelAdministrationClient.beginBuildModel", options, function (finalOptions) {
                  return _this.createTrainingPoller({
                    options: finalOptions,
                    start: function start() {
                      return _this._restClient.buildDocumentModel({
                        modelId: modelId,
                        description: finalOptions.description,
                        azureBlobSource: {
                          containerUrl: containerUrl
                        },
                        buildMode: buildMode
                      }, finalOptions);
                    }
                  });
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function beginBuildModel(_x, _x2, _x3) {
        return _beginBuildModel.apply(this, arguments);
      }

      return beginBuildModel;
    }()
    /**
     * Creates a single composed model from several pre-existing submodels.
     *
     * The resulting composed model combines the document types of its component models, and inserts a classification step
     * into the extraction pipeline to determine which of its component submodels is most appropriate for the given input.
     *
     * ### Example
     *
     * ```javascript
     * const modelId = "aNewComposedModel";
     * const subModelIds = [
     *   "documentType1Model",
     *   "documentType2Model",
     *   "documentType3Model"
     * ];
     *
     * // The resulting composed model can classify and extract data from documents
     * // conforming to any of the above document types
     * const poller = await client.beginComposeModel(modelId, subModelIds, {
     *   description: "This is a composed model that can handle several document types."
     * });
     *
     * // Model composition, like all other model creation operations, returns a poller that eventually produces a
     * // ModelInfo object
     * const modelInfo = await poller.pollUntilDone();
     *
     * const {
     *   modelId, // identical to the modelId given when creating the model
     *   description, // identical to the description given when creating the model
     *   createdDateTime, // the Date (timestamp) that the model was created
     *   docTypes // information about the document types of the composed submodels
     * } = modelInfo;
     * ```
     *
     * @param modelId - the unique ID of the model to create
     * @param componentModelIds - an Iterable of strings representing the unique model IDs of the models to compose
     * @param options - optional settings for model creation
     * @returns a long-running operation (poller) that will eventually produce the created model information or an error
     */

  }, {
    key: "beginComposeModel",
    value: function () {
      var _beginComposeModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(modelId, componentModelIds) {
        var _this2 = this;

        var options,
            _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                return _context2.abrupt("return", this._tracing.withSpan("DocumentModelAdministrationClient.beginComposeModel", options, function (finalOptions) {
                  return _this2.createTrainingPoller({
                    options: finalOptions,
                    start: function start() {
                      return _this2._restClient.composeDocumentModel({
                        modelId: modelId,
                        componentModels: _toConsumableArray(componentModelIds).map(function (submodelId) {
                          return {
                            modelId: submodelId
                          };
                        }),
                        description: finalOptions.description,
                        tags: finalOptions.tags
                      }, finalOptions);
                    }
                  });
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function beginComposeModel(_x4, _x5) {
        return _beginComposeModel.apply(this, arguments);
      }

      return beginComposeModel;
    }()
    /**
     * Creates an authorization to copy a model into the resource, used with the `beginCopyModelTo` method.
     *
     * The `CopyAuthorization` grants another cognitive service resource the right to create a model in this client's
     * resource with the model ID and optional description that are encoded into the authorization.
     *
     * ### Example
     *
     * ```javascript
     * // The copyAuthorization data structure stored below grants any cognitive services resource the right to copy a
     * // model into the client's resource with the given destination model ID.
     * const copyAuthorization = await client.getCopyAuthorization("<destination model ID>");
     * ```
     *
     * @param destinationModelId - the unique ID of the destination model (the ID to copy the model into)
     * @param options - optional settings for creating the copy authorization
     * @returns a copy authorization that encodes the given modelId and optional description
     */

  }, {
    key: "getCopyAuthorization",
    value: function () {
      var _getCopyAuthorization = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(destinationModelId) {
        var _this3 = this;

        var options,
            _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                return _context3.abrupt("return", this._tracing.withSpan("DocumentModelAdministrationClient.getCopyAuthorization", options, function (finalOptions) {
                  return _this3._restClient.authorizeCopyDocumentModel({
                    modelId: destinationModelId,
                    description: finalOptions.description,
                    tags: finalOptions.tags
                  }, finalOptions);
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCopyAuthorization(_x6) {
        return _getCopyAuthorization.apply(this, arguments);
      }

      return getCopyAuthorization;
    }()
    /**
     * Copies a model with the given ID into the resource and model ID encoded by a given copy authorization.
     *
     * See {@link CopyAuthorization} and {@link getCopyAuthorization}.
     *
     * ### Example
     *
     * ```javascript
     * // We need a client for the source model's resource
     * const sourceEndpoint = "https://<source resource name>.cognitiveservices.azure.com";
     * const sourceCredential = new AzureKeyCredential("<source api key>");
     * const sourceClient = new DocumentModelAdministrationClient(sourceEndpoint, sourceCredential);
     *
     * // We create the copy authorization using a client authenticated with the destination resource. Note that these two
     * // resources can be the same (you can copy a model to a new ID in the same resource).
     * const copyAuthorization = await client.getCopyAuthorization("<destination model ID>");
     *
     * // Finally, use the _source_ client to copy the model and await the copy operation
     * const poller = await sourceClient.beginCopyModelTo("<source model ID>");
     *
     * // Model copying, like all other model creation operations, returns a poller that eventually produces a ModelInfo
     * // object
     * const modelInfo = await poller.pollUntilDone();
     *
     * const {
     *   modelId, // identical to the modelId given when creating the copy authorization
     *   description, // identical to the description given when creating the copy authorization
     *   createdDateTime, // the Date (timestamp) that the model was created
     *   docTypes // information about the document types of the model (identical to the original, source model)
     * } = modelInfo;
     * ```
     *
     * @param sourceModelId - the unique ID of the source model that will be copied
     * @param authorization - an authorization to copy the model, created using the {@link getCopyAuthorization}
     * @param options - optional settings for
     * @returns a long-running operation (poller) that will eventually produce the copied model information or an error
     */

  }, {
    key: "beginCopyModelTo",
    value: function () {
      var _beginCopyModelTo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(sourceModelId, authorization) {
        var _this4 = this;

        var options,
            _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                return _context4.abrupt("return", this._tracing.withSpan("DocumentModelAdministrationClient.beginCopyModel", options, function (finalOptions) {
                  return _this4.createTrainingPoller({
                    options: finalOptions,
                    start: function start() {
                      return _this4._restClient.copyDocumentModelTo(sourceModelId, authorization, finalOptions);
                    }
                  });
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function beginCopyModelTo(_x7, _x8) {
        return _beginCopyModelTo.apply(this, arguments);
      }

      return beginCopyModelTo;
    }()
    /**
     * Create an LRO poller that handles training operations.
     *
     * This is the meat of all training polling operations.
     *
     * @param definition - operation definition (start operation method, request options)
     * @returns a training poller that produces a ModelInfo
     */

  }, {
    key: "createTrainingPoller",
    value: function () {
      var _createTrainingPoller = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(definition) {
        var _this5 = this;

        var resumeFrom, toInit, poller;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                resumeFrom = definition.options.resumeFrom;
                toInit = resumeFrom === undefined ? function () {
                  return _this5._tracing.withSpan("DocumentModelAdministrationClient.createTrainingPoller-start", definition.options, /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
                      var _yield$definition$sta, operationLocation;

                      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              _context5.next = 2;
                              return definition.start();

                            case 2:
                              _yield$definition$sta = _context5.sent;
                              operationLocation = _yield$definition$sta.operationLocation;

                              if (!(operationLocation === undefined)) {
                                _context5.next = 6;
                                break;
                              }

                              throw new Error("Unable to start model creation operation: no Operation-Location received.");

                            case 6:
                              return _context5.abrupt("return", _this5._restClient.sendOperationRequest({
                                options: options
                              }, {
                                path: operationLocation,
                                httpMethod: "GET",
                                responses: {
                                  200: {
                                    bodyMapper: Mappers.GetOperationResponse
                                  },
                                  default: {
                                    bodyMapper: Mappers.ErrorResponse
                                  }
                                },
                                headerParameters: [accept1],
                                serializer: SERIALIZER
                              }));

                            case 7:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function (_x10) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                } : function () {
                  return _this5._tracing.withSpan("DocumentModelAdministrationClient.createTrainingPoller-resume", definition.options, function (options) {
                    var _JSON$parse = JSON.parse(resumeFrom),
                        operationId = _JSON$parse.operationId;

                    return _this5._restClient.getOperation(operationId, options);
                  });
                };
                _context9.next = 4;
                return lro({
                  init: function () {
                    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.t0 = toTrainingPollOperationState;
                              _context6.next = 3;
                              return toInit();

                            case 3:
                              _context6.t1 = _context6.sent;
                              return _context6.abrupt("return", (0, _context6.t0)(_context6.t1));

                            case 5:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    function init() {
                      return _init.apply(this, arguments);
                    }

                    return init;
                  }(),
                  poll: function () {
                    var _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref2) {
                      var operationId;
                      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              operationId = _ref2.operationId;
                              return _context8.abrupt("return", _this5._tracing.withSpan("DocumentModelAdminstrationClient.createTrainingPoller-poll", definition.options, /*#__PURE__*/function () {
                                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(options) {
                                  var res;
                                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                                    while (1) {
                                      switch (_context7.prev = _context7.next) {
                                        case 0:
                                          _context7.next = 2;
                                          return _this5._restClient.getOperation(operationId, options);

                                        case 2:
                                          res = _context7.sent;
                                          return _context7.abrupt("return", toTrainingPollOperationState(res));

                                        case 4:
                                        case "end":
                                          return _context7.stop();
                                      }
                                    }
                                  }, _callee7);
                                }));

                                return function (_x12) {
                                  return _ref3.apply(this, arguments);
                                };
                              }()));

                            case 2:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8);
                    }));

                    function poll(_x11) {
                      return _poll.apply(this, arguments);
                    }

                    return poll;
                  }(),
                  serialize: function serialize(_ref4) {
                    var operationId = _ref4.operationId;
                    return JSON.stringify({
                      operationId: operationId
                    });
                  }
                }, definition.options.updateIntervalInMs);

              case 4:
                poller = _context9.sent;

                if (definition.options.onProgress !== undefined) {
                  poller.onProgress(definition.options.onProgress);
                  definition.options.onProgress(poller.getOperationState());
                }

                return _context9.abrupt("return", poller);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function createTrainingPoller(_x9) {
        return _createTrainingPoller.apply(this, arguments);
      }

      return createTrainingPoller;
    }() // #endregion
    // #region Model Management

    /**
     * Retrieve basic information about this client's resource.
     *
     * ### Example
     *
     * ```javascript
     * const {
     *   // Information about the custom models in the current resource
     *   customDocumentModelInfo: {
     *     // The number of custom models in the current resource
     *     count,
     *     // The maximum number of models that the current resource can support
     *     limit
     *   }
     * } = await client.getInfo();
     * ```
     *
     * @param options - optional settings for the request
     * @returns basic information about this client's resource
     */

  }, {
    key: "getInfo",
    value: function getInfo() {
      var _this6 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._tracing.withSpan("DocumentModelAdministrationClient.getInfo", options, function (finalOptions) {
        return _this6._restClient.getInfo(finalOptions);
      });
    }
    /**
     * Retrieves information about a model ({@link ModelInfo}) by ID.
     *
     * This method can retrieve information about custom as well as prebuilt models.
     *
     * ### **Breaking Change**
     *
     * In previous versions of the Form Recognizer REST API and SDK, the `getModel` method could return any model, even
     * one that failed to create due to errors. In the new service versions, `getModel` and `listModels` _only produce
     * successfully created models_ (i.e. models that are "ready" for use). Failed models are now retrieved through the
     * "operations" APIs, see {@link getOperation} and {@link listOperations}.
     *
     * ### Example
     *
     * ```javascript
     * // The ID of the prebuilt business card model
     * const modelId = "prebuilt-businessCard";
     *
     * const {
     *   modelId, // identical to the modelId given when calling `getModel`
     *   description, // a textual description of the model, if provided during model creation
     *   createdDateTime, // the Date (timestamp) that the model was created
     *   // information about the document types in the model and their field schemas
     *   docTypes: {
     *     // the document type of the prebuilt business card model
     *     "prebuilt:businesscard": {
     *       // an optional, textual description of this document type
     *       description,
     *       // the schema of the fields in this document type, see the FieldSchema type
     *       fieldSchema,
     *       // the service's confidences in the fields (an object with field names as properties and numeric confidence
     *       // values)
     *       fieldConfidence
     *     }
     *   }
     * } = await client.getModel(modelId);
     * ```
     *
     * @param modelId - the unique ID of the model to query
     * @param options - optional settings for the request
     * @returns information about the model with the given ID
     */

  }, {
    key: "getModel",
    value: function getModel(modelId) {
      var _this7 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._tracing.withSpan("DocumentModelAdministrationClient.getModel", options, function (finalOptions) {
        return _this7._restClient.getModel(modelId, finalOptions);
      });
    }
    /**
     * List summaries of models in the resource. Custom as well as prebuilt models will be included. This operation
     * supports paging.
     *
     * The model summary ({@link ModelSummary}) includes only the basic information about the model, and does not include
     * information about the document types in the model (such as the field schemas and confidence values).
     *
     * To access the full information about the model, use {@link getModel}.
     *
     * ### **Breaking Change**
     *
     * In previous versions of the Form Recognizer REST API and SDK, the `listModels` method would return all models, even
     * those that failed to create due to errors. In the new service versions, `listModels` and `getModels` _only produce
     * successfully created models_ (i.e. models that are "ready" for use). Failed models are now retrieved through the
     * "operations" APIs, see {@link getOperation} and {@link listOperations}.
     *
     * ### Examples
     *
     * #### Async Iteration
     *
     * ```javascript
     * for await (const summary of client.listModels()) {
     *   const {
     *     modelId, // The model's unique ID
     *     description, // a textual description of the model, if provided during model creation
     *   } = summary;
     *
     *   // You can get the full model info using `getModel`
     *   const model = await client.getModel(modelId);
     * }
     * ```
     *
     * #### By Page
     *
     * ```javascript
     * // The listModels method is paged, and you can iterate by page using the `byPage` method.
     * const pages = client.listModels().byPage();
     *
     * for await (const page of pages) {
     *   // Each page is an array of models and can be iterated synchronously
     *   for (const model of page) {
     *     const {
     *       modelId, // The model's unique ID
     *       description, // a textual description of the model, if provided during model creation
     *     } = summary;
     *
     *     // You can get the full model info using `getModel`
     *     const model = await client.getModel(modelId);
     *   }
     * }
     * ```
     *
     * @param options - optional settings for the model requests
     * @returns an async iterable of model summaries that supports paging
     */

  }, {
    key: "listModels",
    value: function listModels() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._restClient.listModels(options);
    }
    /**
     * Retrieves information about an operation (`OperationInfo`) by its ID.
     *
     * Operations represent non-analysis tasks, such as building, composing, or copying a model.
     *
     * @param operationId - the ID of the operation to query
     * @param options - optional settings for the request
     * @returns information about the operation with the given ID
     *
     * ### Example
     *
     * ```javascript
     * // The ID of the operation, which should be a GUID
     * const operationId = "<operation GUID>";
     *
     * const {
     *   operationId, // identical to the operationId given when calling `getOperation`
     *   kind, // the operation kind, one of "documentModelBuild", "documentModelCompose", or "documentModelCopyTo"
     *   status, // the status of the operation, one of "notStarted", "running", "failed", "succeeded", or "canceled"
     *   percentCompleted, // a number between 0 and 100 representing the progress of the operation
     *   createdDateTime, // a Date object that reflects the time when the operation was started
     *   lastUpdatedDateTime, // a Date object that reflects the time when the operation state was last modified
     * } = await client.getOperation(operationId);
     * ```
     */

  }, {
    key: "getOperation",
    value: function getOperation(operationId) {
      var _this8 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._tracing.withSpan("DocumentModelAdministrationClient.getOperation", options, function (finalOptions) {
        return _this8._restClient.getOperation(operationId, finalOptions);
      });
    }
    /**
     * List model creation operations in the resource. This will produce all operations, including operations that failed
     * to create models successfully. This operation supports paging.
     *
     * ### Examples
     *
     * #### Async Iteration
     *
     * ```javascript
     * for await (const operation of client.listOperations()) {
     *   const {
     *     operationId, // the operation's GUID
     *     status, // the operation status, one of "notStarted", "running", "succeeded", "failed", or "canceled"
     *     percentCompleted // the progress of the operation, from 0 to 100
     *   } = operation;
     * }
     * ```
     *
     * #### By Page
     *
     * ```javascript
     * // The listOperations method is paged, and you can iterate by page using the `byPage` method.
     * const pages = client.listOperations().byPage();
     *
     * for await (const page of pages) {
     *   // Each page is an array of operation info objects and can be iterated synchronously
     *   for (const operation of page) {
     *     const {
     *       operationId, // the operation's GUID
     *       status, // the operation status, one of "notStarted", "running", "succeeded", "failed", or "canceled"
     *       percentCompleted // the progress of the operation, from 0 to 100
     *     } = operation;
     *   }
     * }
     * ```
     *
     * @param options - optional settings for the operation requests
     * @returns an async iterable of operation information objects that supports paging
     */

  }, {
    key: "listOperations",
    value: function listOperations() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._restClient.listOperations(options);
    }
    /**
     * Deletes a model with the given ID from the client's resource, if it exists. This operation CANNOT be reverted.
     *
     * ### Example
     *
     * ```javascript
     * await client.deleteModel("<model ID to delete>"));
     * ```
     *
     * @param modelId - the unique ID of the model to delete from the resource
     * @param options - optional settings for the request
     */

  }, {
    key: "deleteModel",
    value: function deleteModel(modelId) {
      var _this9 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._tracing.withSpan("DocumentModelAdministrationClient.deleteModel", options, function (finalOptions) {
        return _this9._restClient.deleteModel(modelId, finalOptions);
      });
    }
  }]);

  return DocumentModelAdministrationClient;
}();